import * as R from "ramda"

interface Route {
  path: string
  step?: number
}

/**
 * Single source of truth for the funnel routes — the pages the user navigates
 * to via `router.push(ROUTES.x.path)`. Each carries a breadcrumb `step`.
 */
export const ROUTES = {
  petName: { path: "/pet-name", step: 1 },
  petInfo: { path: "/petInfo", step: 2 },
  petBreed: { path: "/pet-breed", step: 3 },
  petBirthdate: { path: "/pet-birthdate", step: 4 },
  tribeQuote: { path: "/tribe-quote", step: 8 },
  tribe: { path: "/tribe", step: 5 },
  attributionQuestion: { path: "/attributionQuestion", step: 6 },
  userMailPhone: { path: "/owner-mail-phone", step: 7 },
  prepackages: { path: "/prepackages", step: 8 },
  liabilityAddOn: { path: "/liability-add-on", step: 8 },
  medicalHistory: { path: "/medical-history", step: 8 },
  healthCoverage: { path: "/coverage", step: 8 },
  healthCoverageParam: { path: "/modalities", step: 8 },
  userInformations: { path: "/owner-informations", step: 10 },
  userBirthInformations: { path: "/owner-birthdate", step: 11 },
  pricing: { path: "/pricing", step: 13 },
  recap: { path: "/recap", step: 14 },
  payment: { path: "/payment", step: 15 },
} as const satisfies Record<string, Route>

/**
 * Path prefixes used only for "which area am I in?" checks
 * (`pathname.includes(...)` / `startsWith(...)`), never as `router.push` targets.
 * Kept separate from `ROUTES` because they are not single navigable destinations.
 */
export const ROUTE_PREFIXES = {
  pet: "/pet",
  owner: "/owner",
  welcome: "/welcome",
  redirect: "/redirect",
  landingPage: "/landing",
} as const

export const ROUTES_ARRAY = R.values(ROUTES)

export function getStepNumber(pathname: string) {
  const currentRoute = R.find(
    (route: Route) => route.step !== undefined && pathname.includes(route.path)
  )(ROUTES_ARRAY)
  return currentRoute?.step || 1
}
